import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { ReportStatus } from '@/shared/graphql/router/graphql'
import { useUserStore } from '@/shared/stores/user'
import { useInfringementProcessingStore } from '../store'

type ReportRow = { report?: { status: ReportStatus } | null }

export const useReportProcessing = (
  rows: MaybeRefOrGetter<readonly ReportRow[]>
) => {
  const userStore = useUserStore()
  const processingStore = useInfringementProcessingStore()

  // User refreshes can lag creation. Keep the indicator on through the
  // handoff from the optimistic row to the server's processing report.
  return computed(
    () =>
      !!userStore.user?.isCreatingReport ||
      processingStore.pendingReportCount > 0 ||
      toValue(rows).some(
        (row) => row.report?.status === ReportStatus.Processing
      )
  )
}
